/**
 * V2 Process Support
 * 
 * Contains any functionality that should be added on when v2 process is in use
 */
define('components/v2-process-support',[
    'jquery',
    'logging',
    'application'
], function($, logging, app) {
    'use strict';
    
    var _ModuleName = "V2 Process Support";
    var _config = {
        enabled: false,
        watchTimer: 1e3,
        maxWatchChecks: 0,
        lastHeight: 0,
        watchSubscription: null
    }

    /**
     * Init function is run imediatly, so DOM is not necessarily available.
     * This can be used for getting things ready such as config storage and such
     * @param {object} config Configuration object with data parameters passed in
     */
    var init = function(config) {
        // check if we should enable this
        if(app.getProcessVersionNumber() == "2.0") {
            _config.enabled = true;
        }
    }

    /**
     * Run function on only run after the DOM is ready
     * This can be used for any DOM manipulation code that needs to run
     */
    var run = function() {
        if(_config.enabled) {
            logging.debug("Process Version 2 is in use so setting up our height reporting stuff", _ModuleName);
        
            _config.lastHeight = _getHeight() || window.innerHeight;

            logging.debug("Initial Height measured at " + _config.lastHeight + "px", _ModuleName);
            if(_config.lastHeight === 0) {
                logging.debug("Initial height check was 0px so we're going to wait and check again");
                _config.maxWatchChecks++;
            } else {
                app.notifyParentOfFrameHeightUpdate(_config.lastHeight);
            }

            if(_config.maxWatchChecks > 0) {
                logging.debug("Configuring an interval based watch to detect height changes.", _ModuleName);
                _config.watchSubscription = window.setInterval(_checkForHeightUpdates, _config.watchTimer);
            }
        }
    }

    var _checkForHeightUpdates = function() {  
        // if we're done watching for updates, try clearing the interval and return
        if(_config.maxWatchChecks === 0) {
            if(_config.watchSubscription != null) {
                window.clearInterval(_config.watchSubscription);
            }

            return;
        }

        var height = _getHeight();

        if(typeof(height) != 'undefined' && height != null && Math.abs(height - _config.lastHeight) > 25) {
            logging.debug("Height Change Detected. New height is " + height + "px.", _ModuleName);
            app.notifyParentOfFrameHeightUpdate(height);
            _config.lastHeight = height;
        }

        _config.maxWatchChecks--;
    }

    var _getHeight = function() {
        var height = (typeof window.innerHeight != 'undefined')
            ? Math.max(document.body.clientHeight, window.innerHeight)
            : document.body.clientHeight;
        
        var rootElement = $('#lp-pom-root');
        if(rootElement && rootElement.length) {
            height = Math.max($(document).height(), rootElement.length ? rootElement.height() : 0, rootElement.length ? rootElement.outerHeight() : 0);
        }
        
        return height;
    }
    
    return {
        init: init,
        run: run
    }
});
